'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var style = require('./style.js');
var compose = require('./compose.js');

var displayPrint = style({
  prop: 'displayPrint',
  cssProperty: false,
  transform: function transform(value) {
    return {
      '@media print': {
        display: value
      }
    };
  }
});
var displayRaw = style({
  prop: 'display'
});
var overflow = style({
  prop: 'overflow'
});
var textOverflow = style({
  prop: 'textOverflow'
});
var visibility = style({
  prop: 'visibility'
});
var whiteSpace = style({
  prop: 'whiteSpace'
});
var display = compose(displayPrint, displayRaw, overflow, textOverflow, visibility, whiteSpace);

exports["default"] = display;
exports.displayPrint = displayPrint;
exports.displayRaw = displayRaw;
exports.overflow = overflow;
exports.textOverflow = textOverflow;
exports.visibility = visibility;
exports.whiteSpace = whiteSpace;
